import { render, staticRenderFns } from "./PracticeMCD.vue?vue&type=template&id=8d8b0bfe&scoped=true"
import script from "./PracticeMCD.vue?vue&type=script&lang=js"
export * from "./PracticeMCD.vue?vue&type=script&lang=js"
import style0 from "./PracticeMCD.vue?vue&type=style&index=0&id=8d8b0bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8b0bfe",
  null
  
)

export default component.exports